import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable()
export class HttpClientInterceptor implements HttpInterceptor {
  
  constructor(/*private permissionService: PermissionService, private cookieService: CookieService*/) {}

  intercept(httpRequest: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    
    //console.log("HTTP CLIENT INTERCEPTOR - CALLING URL: " + httpRequest.url);

    let clientUuid: string;
    const randomInt = (min, max) =>
        Math.floor(Math.random() * (max - min + 1)) + min;
    let randomNumber: number = randomInt(1, 100);
    
    if (httpRequest.url.indexOf(environment.membershipBackendAddress) > -1) {
      clientUuid = environment.winoMembershipClient_uuid;
    } else if (httpRequest.url.indexOf(environment.libraryBackendAddress) > -1) {
      clientUuid = environment.winoLibraryClient_uuid;
    } else if (httpRequest.url.indexOf(environment.publishingBackendAddress) > -1) {
      clientUuid = environment.winoPublishingClient_uuid;
    } else {
      console.log("HttpClientInterceptor - ATTENTION: no client-uuid found...")
      clientUuid = "";
    }

    console.log("HttpClientInterceptor - UUID: " + (clientUuid.length > 0 ? "OK" : "KKKOOO"));
    httpRequest = httpRequest.clone({
      withCredentials: true,
      headers:httpRequest.headers.append('client-uuid', clientUuid).append('requestRandomId', randomNumber.toString())
    });

    //console.log("COOKIE WINO AUTH TOKEN: " + this.cookieService.get("winoAuthToken"));

    //console.log("AUTH INTERCEPTOR");
    //this.permissionService.checkAuthentication();
    
    //const token = this.cookieService.getAccessToken();
        
    // console.log('JWT TOKEN: ' + token);
    // console.log('Access Token: ' + httpRequest.urlWithParams);
    // console.log('Http Request: ' + httpRequest.body);

    return next.handle(httpRequest);
    /*******************************************
    if(token) {
        const clone = httpRequest.clone( {
            headers: httpRequest.headers.set('Authorization', 'Bearer ' + token)
        });
        //clone.headers.append('Authorization', 'Bearer ' + token);
        return next.handle(clone);
    } else {
        return next.handle(httpRequest);
    }
    **************************************/
  }
}